import React, { CSSProperties, useState } from 'react'
import { CertificateItemType } from './types'

// Components
import Loading from '../Loading'
import ModalAwards from '../ModalAwards'

// Styles
import './styles.scss'

// Icons
import IconFlag from './images/iconFlag'

export default ({
  certificates,
  isLoading,
  style,
}: {
  certificates: CertificateItemType[]
  isLoading: boolean
  style?: CSSProperties
}) => {
  const [modal, setModal] = useState<boolean>(false)

  const hasCertificates = certificates && certificates.length && !isLoading

  return (
    <>
      <div style={style} className={'awards-edit-block'}>
        <div className={'awards-edit-block__title'}>Награды</div>
        <div className={'awards-edit-block__flag'}>
          <IconFlag />
        </div>
        <button
          onClick={() => setModal(true)}
          disabled={!hasCertificates}
          className={'awards-edit-block__button'}
        >
          {isLoading ? (
            <Loading color={'#219321'} />
          ) : (
            <>
              Посмотреть
              <br />
              все награды
            </>
          )}
        </button>
      </div>
      {hasCertificates ? (
        <ModalAwards
          modal={modal}
          close={() => setModal(false)}
          certificates={certificates}
        />
      ) : null}
    </>
  )
}
